import { Fragment } from 'react';

import { useQuery } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { AppCard } from '@components/app-card';
import { IconApp } from '@components/icons/app';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { api } from 'api';

import { Loading } from 'components/Loading';
import { ADManagerApplicationApp } from 'integrations/adManager/application-app-page';
import { HireflixApplicationApp } from 'integrations/hireflix/ApplicationAppPage';
import { useStore } from 'models/Provider';

const appToComponentMapper = {
  'AD Manager': <ADManagerApplicationApp />,
  Hireflix: <HireflixApplicationApp />,
};

export const ApplicationApps = observer(({ application }) => {
  const { t } = useStore();

  const applicationAppsQuery = useQuery({
    queryKey: ['applicationApps'],
    queryFn: () => api.integrations.applicationPreHireApps(application.id),
  });

  return (
    <Container>
      {applicationAppsQuery.isLoading && <Loading />}
      {applicationAppsQuery.isSuccess && applicationAppsQuery.data.length === 0 && (
        <AppCard variant="gray" padding="lg">
          <Stack space={2} orientation="horizontal" align="center">
            <IconApp color="purple60" />
            <Text
              font="semibold14"
              color="purple80"
              text={t('integrations.hireflix.application.noapps')}
            />
          </Stack>
        </AppCard>
      )}
      <Stack space={6}>
        {applicationAppsQuery.isSuccess &&
          applicationAppsQuery.data.length > 0 &&
          applicationAppsQuery.data
            .filter((integration) => !integration.isBlocked)
            .map((integration, i, arr) => {
              return (
                <Fragment key={integration.name}>
                  <div>{appToComponentMapper[integration.name]}</div>
                  {arr.length - 1 !== i && <Separator />}
                </Fragment>
              );
            })}
      </Stack>
    </Container>
  );
});

const Container = styled.div((p) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(9, 1fr)',
  marginTop: '1.5rem',
  columnGap: p.theme.spacing.m16,
  rowGap: p.theme.spacing.m8,
  '> div': {
    gridColumn: 'span 6',
  },

  '@media(max-width: 768px)': {
    '> div': {
      gridColumn: 'span 9',
    },
  },
}));
